<template>
  <div>
    <p class="text-2xl mb-6">Dashboard Programmatique</p>
    <v-card class="mb-6 pa-2">
      <v-row class="ma-3">
        <v-col cols="12">
          <filters :showGroupCASwitch="true"></filters>
        </v-col>
      </v-row>
    </v-card>

    <top-cards />

    <v-row>
      <v-col v-if="groupCA" cols="8">
        <ca-objectives-chart />
      </v-col>
      <v-col cols="8" v-else>
        <ca-by-partner-view-chart />
      </v-col>
      <v-col cols="4">
        <c-a-distribution-chart store="premium" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <sessions-objectives-chart />
      </v-col>
      <v-col cols="6">
        <rpms-objectives-chart />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <rpmv-sessions-chart />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CaByPartnerViewChart from "@/components/premium/general/cards/CaByPartnerViewChart";
import CADistributionChart from "@/components/general/dashboard/cards/CADistributionChart";
import CaObjectivesChart from "@/components/premium/general/cards/CaObjectivesChart";
import Filters from "@/components/premium/general/filters/Filters";
import RpmsObjectivesChart from "@/components/premium/general/cards/RPMSObjectivesChart";
import RpmvSessionsChart from "@/components/premium/general/cards/RPMVObjectivesChart";
import SessionsObjectivesChart from "@/components/premium/general/cards/SessionsObjectivesChart";
import TopCards from "@/components/premium/general/cards/TopCards";

import { saveRmraView } from "@/utils/rmr-analytics";

export default {
  name: "GeneralDecoupled",
  components: {
    Filters,
    TopCards,
    CaObjectivesChart,
    CaByPartnerViewChart,
    CADistributionChart,
    SessionsObjectivesChart,
    RpmsObjectivesChart,
    RpmvSessionsChart,
  },
  async created() {
    const monthDate = new Intl.DateTimeFormat("fr-FR")
      .format(new Date())
      .split("/");
    this.$store.dispatch(
      "premium/updateMonthDate",
      `${monthDate[2]}-${monthDate[1]}`
    );
  },
  mounted() {
    saveRmraView(this.$route);

    this.setDefaultFilters();
  },
  methods: {
    async setDefaultFilters() {
      if (
        this.$route?.query?.partnerViews ||
        this.$route?.query?.partnerViewGroups
      ) {
        return;
      }

      const partnerViewGroups = await this.$store.dispatch(
        "common/getPartnerViewGroupList"
      );
      const exportSuiviGeneral = partnerViewGroups.find(
        (g) => g.name === "Export Suivi Général"
      );

      this.$store.dispatch(
        "premium/updatePartnerViewGroups",
        exportSuiviGeneral ? [exportSuiviGeneral.id] : [] //
      );
    },
  },
  computed: {
    groupCA() {
      return this.$store.getters["premium/getGroupCA"];
    },
  },
};
</script>
